// src/utils/commonMethods.js

function getStockData(row) {
  if (!row) {
    console.error('Invalid row data');
    return null;
  }
  return row;
}

export function onPrice(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  const searchQuery = `${stock[2]} ${stock[1]}`;
  const url = router.resolve({ name: 'StockSearchFormPage', query: { searchQuery } }).href;
  window.open(url, '_blank');
}

export function onLHB(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  const [stock_code] = stock[1].split('.');
  const url = router.resolve({ name: 'StockDetailPage', query: { stock_code } }).href;
  window.open(url, '_blank');
}

export function onLine(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const [searchQuery, searchQuery1] = stock[1].split('.');
  const externalUrl = `https://xueqiu.com/s/${encodeURIComponent(searchQuery1 + searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onWenCai(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = stock[2];
  const externalUrl = `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onPrice1(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = `${stock['股票简称']} ${stock['股票代码']}`;
  const url = router.resolve({ name: 'StockSearchFormPage', query: { searchQuery } }).href;
  window.open(url, '_blank');
}

export function onWenCai1(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const searchQuery = stock['股票简称'];
  const externalUrl = `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${encodeURIComponent(searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onLine1(responseData, row) {
  const stock = getStockData(row);
  if (!stock) return;

  const [searchQuery, searchQuery1] = stock['股票代码'].split('.');
  const externalUrl = `https://xueqiu.com/s/${encodeURIComponent(searchQuery1 + searchQuery)}`;
  window.open(externalUrl, '_blank');
}

export function onLHB1(responseData, row, router) {
  const stock = getStockData(row);
  if (!stock) return;
  const [stock_code] = stock['股票代码'].split('.');
  const url = router.resolve({ name: 'StockDetailPage', query: { stock_code } }).href;
  window.open(url, '_blank');
}

export function formatDate(selectedDate) {
      const date = new Date(selectedDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
}

export function  getPreviousDate() {

      const date = new Date();
      date.setDate(date.getDate() - 1);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
}
